import { render, staticRenderFns } from "./representation.vue?vue&type=template&id=6d41729e&scoped=true"
import script from "./representation.vue?vue&type=script&lang=js"
export * from "./representation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d41729e",
  null
  
)

export default component.exports